import React from 'react'

import { Field } from 'formik'

import { Col, Form, Button } from '_zari/core'

import { Select2GlosaxSocio, Select2Glosa } from 'sharedComponents/select2'

import { OrigenesContabilidadConstant, TiposGuardadoGlosaConstant } from 'constants/index'

import { KeyEventUtil, IdGen } from 'utils'

import * as GlosaService from 'services/glosasContabilidad.service'

const GlosaFormGroup = ({
  setFieldValue,
  fIsSubmitting,
  vSocio,
  iError,
  iTouched,
  cabeceraDetalleFormikRef,
  vOrigen,
  vTipoGuardadoGlosa,
  prevDataGlosa
}) => {
  const onIdChange = React.useCallback(
    id => {
      if (cabeceraDetalleFormikRef.current) {
        if (id) {
          setFieldValue('_idGlosa', id)

          GlosaService.getInfo(id).then(({ data }) => {
            cabeceraDetalleFormikRef.current.setValues({
              ...cabeceraDetalleFormikRef.current.values,
              __keyCuentaContable: IdGen.newId(),
              cuentaContable: data.cuentaContableInfo ? data.cuentaContable || '' : '',
              cuentaContableInfo: data.cuentaContableInfo || '',
              cuentaDestino: data.cuentaDestino || '',
              cuentaDestinoInfo: data.cuentaDestinoInfo || '',
              flagCentroCosto: data.flagCentroCosto || false,
              esCuentaActivoFijo: data.esCuentaActivoFijo || false,
              _idCentroCostoNivel1: data._idCentroCostoNivel1 || '',
              _idCentroCostoNivel2: data._idCentroCostoNivel2 || '',
              _idActivoFijo: data._idActivoFijo || '',
              tipoMovimientoActivo: data.tipoMovimientoActivo || '',
              centroCostoNivel1Info: data.centroCostoNivel1Info || '',
              centroCostoNivel2Info: data.centroCostoNivel2Info || ''
            })
          })
        } else {
          setFieldValue('_idGlosa', '')

          cabeceraDetalleFormikRef.current.setValues({
            ...cabeceraDetalleFormikRef.current.values,
            __keyCuentaContable: IdGen.newId(),
            cuentaContable: '',
            cuentaDestino: '',
            cuentaDestinoInfo: '',
            cuentaContableInfo: '',
            flagCentroCosto: false,
            centroCostoInfo: '',
            _idCentroCosto: ''
          })
        }
      }
    },
    [setFieldValue, cabeceraDetalleFormikRef]
  )

  const oneRowTrigger = React.useCallback(
    ({ _id, nombre }) => {
      setFieldValue('_idGlosa', _id)
      setFieldValue('glosa', nombre)

      // KeyEventUtil.leaveOnKeyEvent('input-serieDocumento')

      if (cabeceraDetalleFormikRef.current) {
        GlosaService.getInfo(_id).then(({ data }) => {
          cabeceraDetalleFormikRef.current.setValues({
            ...cabeceraDetalleFormikRef.current.values,
            __keyCuentaContable: IdGen.newId(),
            cuentaContable: data.cuentaContableInfo ? data.cuentaContable || '' : '',
            cuentaContableInfo: data.cuentaContableInfo || '',
            cuentaDestino: data.cuentaDestino || '',
            cuentaDestinoInfo: data.cuentaDestinoInfo || '',
            flagCentroCosto: data.flagCentroCosto || false,
            esCuentaActivoFijo: data.esCuentaActivoFijo || false,
            _idCentroCostoNivel1: data._idCentroCostoNivel1 || '',
            _idCentroCostoNivel2: data._idCentroCostoNivel2 || '',
            _idActivoFijo: data._idActivoFijo || '',
            tipoMovimientoActivo: data.tipoMovimientoActivo || '',
            centroCostoNivel1Info: data.centroCostoNivel1Info || '',
            centroCostoNivel2Info: data.centroCostoNivel2Info || ''
          })
        })
      }
    },
    [cabeceraDetalleFormikRef, setFieldValue]
  )

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-glosaComplemento', e)
  }, [])

  const onKeyDownGlosaComplemento = React.useCallback(
    e => {
      KeyEventUtil.leaveOnEnterOrTab(
        vOrigen === OrigenesContabilidadConstant.COMPRAS ? 'input-serieDocumento' : 'select-tipoDocumento',
        e
      )
    },
    [vOrigen]
  )

  const clickTipoGuardado = React.useCallback(() => {
    if (vTipoGuardadoGlosa === TiposGuardadoGlosaConstant.PERSONALIZADO) {
      setFieldValue('tipoGuardadoGlosa', TiposGuardadoGlosaConstant.GENERAL)
    } else {
      setFieldValue('tipoGuardadoGlosa', TiposGuardadoGlosaConstant.PERSONALIZADO)
    }
  }, [vTipoGuardadoGlosa, setFieldValue])

  return (
    <Form.Group>
      <Form.Label text='GLOSA' htmlFor='inputselect-glosa' md={2} alignRightAt='md' />
      <Col md={10}>
        <Form.InputGroup>
          {vOrigen === OrigenesContabilidadConstant.COMPRAS ? (
            <>
              <Form.InputGroup.Prepend>
                <Button onClick={clickTipoGuardado}>{vTipoGuardadoGlosa}</Button>
              </Form.InputGroup.Prepend>
              {vTipoGuardadoGlosa === TiposGuardadoGlosaConstant.PERSONALIZADO ? (
                <Field name='glosa'>
                  {({ field }) => (
                    <Select2GlosaxSocio
                      {...field}
                      id='inputselect-glosa'
                      idSocio={vSocio}
                      onIdChange={onIdChange}
                      isInvalid={iTouched && iError}
                      disabled={fIsSubmitting}
                      onKeyDown={onKeyDown}
                      oneRowTrigger={oneRowTrigger}
                      initialValue={prevDataGlosa}
                    />
                  )}
                </Field>
              ) : (
                <Field name='glosa'>
                  {({ field }) => (
                    <Select2Glosa
                      {...field}
                      id='inputselect-glosa'
                      onIdChange={onIdChange}
                      isInvalid={iTouched && iError}
                      disabled={fIsSubmitting}
                      onKeyDown={onKeyDown}
                      oneRowTrigger={oneRowTrigger}
                      initialValue={prevDataGlosa}
                    />
                  )}
                </Field>
              )}
              <Form.InputGroup.Append>
                <Field name='glosaComplemento'>
                  {({ field }) => (
                    <Form.InputText
                      {...field}
                      id='input-glosaComplemento'
                      isInvalid={iTouched && iError}
                      disabled={fIsSubmitting || !vSocio}
                      onKeyDown={onKeyDownGlosaComplemento}
                    />
                  )}
                </Field>
              </Form.InputGroup.Append>
            </>
          ) : (
            <>
              <Field name='glosa'>
                {({ field }) => (
                  <Select2Glosa
                    {...field}
                    id='inputselect-glosa'
                    onIdChange={onIdChange}
                    isInvalid={iTouched && iError}
                    disabled={fIsSubmitting}
                    onKeyDown={onKeyDown}
                    oneRowTrigger={oneRowTrigger}
                    initialValue={prevDataGlosa}
                  />
                )}
              </Field>
              <Form.InputGroup.Append>
                <Field name='glosaComplemento'>
                  {({ field }) => (
                    <Form.InputText
                      {...field}
                      id='input-glosaComplemento'
                      isInvalid={iTouched && iError}
                      disabled={fIsSubmitting || !vSocio}
                      onKeyDown={onKeyDownGlosaComplemento}
                    />
                  )}
                </Field>
              </Form.InputGroup.Append>
            </>
          )}
        </Form.InputGroup>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(GlosaFormGroup)
